import DataTable from "../../../Components/DataTable/DataTable";
import {
  ExclamationCircleFilled,
  NodeIndexOutlined,
  WarningFilled,
} from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState } from "react";
import * as actions from "../../../store/actions/action";
import api from "../../../api/api";
import { connect } from "react-redux";
import { Button, Form, Input, Modal, Select, Tag, message } from "antd";
import WayMapper from "../../../Util/WayMapper";
import CheckPermission from "../../../Util/CheckPermission";
import { useNavigate } from "react-router-dom";
import { editError } from "../../../Util/Messages";
import ExportExcel from "../../../Util/ExportExcel";
import { toJalaali, toGregorian } from "jalaali-js";
import moment from "moment/moment";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import jalali from "react-date-object/calendars/jalali";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

const LinksEditor = ({ value, onChange }) => {
  const text = Array.isArray(value) ? value.join("\n") : value ?? "";
  return (
    <Input.TextArea
      value={text}
      placeholder="لینک"
      autoSize={{ minRows: 1, maxRows: 6 }}
      onChange={(e) => onChange?.(e.target.value)}
    />
  );
};

const Ways = ({
  rowSelection,
  LoadingSetter,
  ClearLoading,
  loading,
  ClearError,
  ErrorSetter,
  permissions,
  waysData,
}) => {
  const TypeFilter = Object.keys(WayMapper).map((key) => {
    return {
      value: key,
      text: WayMapper[key].title,
    };
  });
  const [data, setData] = useState();
  const [editableKeys, setEditableRowKeys] = useState();
  const [editingRecord, setEditingRecord] = useState();
  const [pagination, setPagination] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [newLink, setNewLink] = useState(null);
  const [tags, setTags] = useState([]);
  const [productTags, setProductTags] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [confirmRecord, setConfirmRecord] = useState({});
  const [confirmRecordSkills, setConfirmRecordSkills] = useState([]);
  const [expireExists, setExpireExists] = useState();
  const [d, setD] = useState();

  // const [columns, setColumns] = useState([
  //   // type
  //   {
  //     title: "نوع ",
  //     dataIndex: "type",
  //     filters: TypeFilter,
  //     onFilter: (value, record) => {
  //       if (record.type) {
  //         return record.type.includes(value);
  //       } else {
  //         return true;
  //       }
  //     },
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <Select>
  //             {Object.keys(WayMapper).map((key) => (
  //               <Select.Option value={key}>
  //                 {WayMapper[key].title}
  //               </Select.Option>
  //             ))}
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (text, row) => (
  //       <div>{WayMapper[text] ? WayMapper[text].title : ""}</div>
  //     ),
  //   },
  //   // title
  //   {
  //     title: "نام",
  //     dataIndex: "title",
  //     searchable: true,
  //   },
  //   // product
  //   {
  //     title: "نوع محصول",
  //     dataIndex: "productTags",
  //     filters: productTags?.map((el) => ({ value: el, text: el })),

  //     onFilter: (value, record) => record?.productTags?.includes(value),
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <Select
  //             defaultValue={record.productTags}
  //             mode="tags"
  //             allowClear
  //             style={{ width: "100%" }}
  //             placeholder="نوع محصول"
  //           >
  //             {Array.from(
  //               new Set(
  //                 []
  //                   .concat(...(data ?? [])?.map((el) => el.productTags))
  //                   .filter((e) => e)
  //               )
  //             )?.map((tag) => (
  //               <Select.Option key={tag} value={tag}>
  //                 {tag}
  //               </Select.Option>
  //             ))}
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (_, record) => {
  //       if (
  //         !Array.isArray(record.productTags) ||
  //         record?.productTags?.length === 0
  //       ) {
  //         return <Tag color="red">بدون تگ</Tag>;
  //       }
  //       return (
  //         record?.productTags?.map((el) => (
  //           <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
  //         )) ?? "-"
  //       );
  //     },
  //   },
  //   // tags
  //   {
  //     title: "تگ",
  //     dataIndex: "tags",
  //     filterSearch: true,
  //     filters: (tags ?? [])?.map((el) => ({ value: el, text: el })),
  //     onFilter: (value, record) => record?.tags?.indexOf(value) !== -1,

  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <Select
  //             defaultValue={record.tags}
  //             mode="tags"
  //             allowClear
  //             style={{ width: "100%" }}
  //             placeholder="تگ"
  //           >
  //             {(tags ?? [])?.map((tag) => (
  //               <Select.Option key={tag} value={tag}>
  //                 {tag}
  //               </Select.Option>
  //             ))}
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (_, record) => {
  //       if (!Array.isArray(record.tags) || record?.tags?.length === 0) {
  //         return <Tag color="red">بدون تگ</Tag>;
  //       }
  //       return (
  //         record?.tags?.map((el) => (
  //           <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
  //         )) ?? "-"
  //       );
  //     },
  //   },
  //   // isFree
  //   {
  //     title: "هزینه",
  //     dataIndex: "isFree",
  //     filterMultiple: false,
  //     filters: [
  //       {
  //         value: "رایگان",
  //         text: true,
  //       },
  //       {
  //         value: "پولی",
  //         text: false,
  //       },
  //     ],
  //     onFilter: (value, record) => record?.isFree === value,

  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         const defaultValue =
  //           typeof record.isFree === "boolean" ? record.isFree : null;

  //         return (
  //           <Select
  //             defaultValue={defaultValue}
  //             allowClear
  //             style={{ width: "100%" }}
  //             placeholder="هزینه"
  //           >
  //             <Select.Option value={false}>پولی</Select.Option>
  //             <Select.Option value={true}>رایگان</Select.Option>
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (_, row) => {
  //       if (typeof row.isFree !== "boolean") {
  //         return (
  //           <Tag color="red" style={{ margin: "0.25rem" }}>
  //             نامشخص
  //           </Tag>
  //         );
  //       }

  //       return row.isFree ? (
  //         <Tag color="green" style={{ margin: "0.25rem" }}>
  //           رایگان
  //         </Tag>
  //       ) : (
  //         <Tag color="blue" style={{ margin: "0.25rem" }}>
  //           پولی
  //         </Tag>
  //       );
  //     },
  //   },
  //   // discountCode
  //   {
  //     title: "کد تخفیف روش یادگیری",
  //     dataIndex: "discountCode",
  //     filters: discounts.map((discount) => ({
  //       text: discount.percentage
  //         ? `${discount.title} - ${discount?.percentage} درصد`
  //         : discount.title,
  //       value: discount.id,
  //     })),
  //     onFilter: (value, record) => record?.discountCode === value,

  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <Select
  //             defaultValue={record.discountCode}
  //             allowClear
  //             style={{ width: "100%" }}
  //             placeholder="تخفیف"
  //           >
  //             {discounts.map((discount) => (
  //               <Select.Option value={discount.id}>
  //                 {discount.percentage
  //                   ? `${discount.title} - ${discount?.percentage} درصد`
  //                   : discount.title}
  //               </Select.Option>
  //             ))}
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (_, row) => {
  //       const discount = discounts.find(({ id }) => id === row.discountCode);
  //       if (!discount) {
  //         return <Tag color="red">ندارد</Tag>;
  //       }

  //       return (
  //         <Tag color="green" style={{ margin: "0.25rem" }}>
  //           {discount.percentage
  //             ? `${discount.title} - ${discount?.percentage} درصد`
  //             : discount.title}
  //         </Tag>
  //       );
  //     },
  //   },
  //   {
  //     title: "تاریخ انقضا",
  //     dataIndex: "expireAt",
  //     width: "10%",
  //     render: (text, record) => {
  //       if (!text) return "-";
  //       let date = new Date(text);

  //       // real payment date
  //       if (moment(date).isValid()) {
  //         const jalali = toJalaali(
  //           date.getFullYear(),
  //           date.getMonth() + 1,
  //           date.getDate()
  //         );
  //         return (
  //           <span>
  //             {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
  //           </span>
  //         );
  //       }

  //       return <span>-</span>;
  //     },
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <>
  //             <DatePicker
  //               value={record.expireAt}
  //               format="YYYY/MM/DD"
  //               calendar={jalali}
  //               locale={persian_fa}
  //               render={(value, openCalendar) => {
  //                 return (
  //                   <div
  //                     style={{
  //                       display: "flex",
  //                       alignItems: "center",
  //                       gap: "0.5rem",
  //                     }}
  //                   >
  //                     {record.id == kia ? "same" : "not"}
  //                     {record.id !== expireExists && (
  //                       <Input value={value} onClick={openCalendar} />
  //                     )}

  //                     {record.id !== expireExists ? (
  //                       <ClearIcon
  //                         onClick={() => {
  //                           console.log("here", record.id, expireExists);
  //                           setKia(record.id);
  //                           setExpireExists({ id: record.id });
  //                           console.log("after");
  //                         }}
  //                         fontSize="small"
  //                       />
  //                     ) : (
  //                       <AddIcon
  //                         onClick={() => setExpireExists()}
  //                         fontSize="small"
  //                       />
  //                     )}
  //                   </div>
  //                 );
  //               }}
  //             />
  //           </>
  //         );
  //       }
  //     },
  //   },
  //   {
  //     title: "VPN",
  //     dataIndex: "vpn",
  //     filters: [{ value: true, text: "VPN" }],
  //     onFilter: (value, record) => record?.vpn === value,
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <Select
  //             defaultValue={typeof record.vpn === "boolean" ? record.vpn : null}
  //             allowClear
  //             style={{ width: "100%" }}
  //             placeholder="-"
  //           >
  //             <Select.Option value={true}>VPN</Select.Option>
  //           </Select>
  //         );
  //       }
  //     },
  //     render: (_, row) => {
  //       if (typeof row.vpn !== "boolean") return "-";

  //       if (row?.vpn) return <Tag color="red">VPN</Tag>;
  //     },
  //   },
  //   {
  //     title: "توضیحات",
  //     dataIndex: "description",
  //   },
  //   {
  //     title: "مهارت‌های متصل",
  //     dataIndex: "skills",
  //     filters: [
  //       {
  //         value: "has_skill",
  //         text: "مهارت دار",
  //       },
  //       {
  //         value: "no_skill",
  //         text: "بدون مهارت",
  //       },
  //     ],
  //     onFilter: (value, record) => {
  //       let hasSkill = true;
  //       if (Array.isArray(record.skills)) {
  //         if (record.skills.length === 0) {
  //           hasSkill = false;
  //         }
  //       }
  //       switch (value) {
  //         case "has_skill":
  //           return hasSkill;
  //         case "no_skill":
  //           return !hasSkill;
  //         default:
  //           return hasSkill;
  //       }
  //     },
  //     // renderFormItem: (_, { isEditable, record  }) => {
  //     //   if (isEditable) {
  //     //     return (
  //     //       <div>
  //     //         {Array.isArray(record.links)
  //     //           ? record.links.map((link , index) =>
  //     //           <Tooltip title={link}>
  //     //           <Tag closable onClose={()=>{removeLink(link , record)}}>لینک {index + 1}</Tag>
  //     //           </Tooltip>)
  //     //           : null}
  //     //          <Button onClick={()=>{
  //     //         setOpenModal(true);
  //     //         setEditingRecord(record)
  //     //       }}>ساخت لینک جدید</Button>
  //     //       </div>
  //     //     );
  //     //   }
  //     // },
  //     render: (text, row) => {
  //       const ErrorElement = (
  //         <div>
  //           <ExclamationCircleFilled /> روش یادگیری به هیچ مهارتی متصل نیست.
  //         </div>
  //       );
  //       if (Array.isArray(row.skills)) {
  //         if (row.skills.length === 0) {
  //           return ErrorElement;
  //         }
  //         return (
  //           <div>
  //             {row.skills.map((skill, index) => (
  //               <Tag style={{ margin: "0.25rem" }}>{skill.title}</Tag>
  //             ))}
  //           </div>
  //         );
  //       } else {
  //         return ErrorElement;
  //       }
  //     },
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return (
  //           <>
  //             {Array.isArray(record.skills)
  //               ? record.skills.map((el) => (
  //                   <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
  //                 ))
  //               : null}
  //           </>
  //         );
  //       }
  //     },
  //   },
  //   {
  //     title: "لینک‌ها",
  //     dataIndex: "links",
  //     filters: [
  //       {
  //         value: "has_link",
  //         text: "لینک دار",
  //       },
  //       {
  //         value: "no_link",
  //         text: "بدون لینک",
  //       },
  //     ],
  //     onFilter: (value, record) => {
  //       let hasLink = false;
  //       if (Array.isArray(record.links)) {
  //         if (record.links.length !== 0) {
  //           hasLink = true;
  //         }
  //       }
  //       switch (value) {
  //         case "has_link":
  //           return hasLink;
  //         case "no_link":
  //           return !hasLink;
  //         default:
  //           return hasLink;
  //       }
  //     },
  //     renderFormItem: (_, { isEditable, record }) => {
  //       if (isEditable) {
  //         return <Input.TextArea />;
  //       }
  //     },
  //     render: (text, row) => {
  //       if (Array.isArray(row.links) || `${row.links}`.length > 10) {
  //         if (row.links.length === 0) {
  //           return (
  //             <div>
  //               <WarningFilled /> روش یادگیری بدون لینک است.
  //             </div>
  //           );
  //         }
  //         return (
  //           <a target="_blank" rel="noreferrer" href={row.links.toString()}>
  //             لینک
  //           </a>
  //         );
  //       } else {
  //         return (
  //           <div>
  //             <WarningFilled /> روش یادگیری بدون لینک است.
  //           </div>
  //         );
  //       }
  //     },
  //   },
  //   {
  //     title: "تاریخ ساخت ",
  //     width: "8%",
  //     align: "center",
  //     dataIndex: "createdAt",
  //     editable: false,
  //     sorter: (a, b) => {
  //       const Adate = new Date(a.createdAt);
  //       const Bdate = new Date(b.createdAt);

  //       return Bdate - Adate;
  //     },
  //     render: (text, record) => {
  //       const date = text ? new Date(text) : new Date();
  //       const jalali = toJalaali(
  //         date.getFullYear(),
  //         date.getMonth() + 1,
  //         date.getDate()
  //       );
  //       return (
  //         <span>
  //           {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
  //         </span>
  //       );
  //     },
  //   },
  // ]);

  const navigate = useNavigate();
  const setColumns = () => {};
  const columns = useMemo(() => {
    const arr = [
      // type
      {
        title: "نوع",
        width: 90,
        dataIndex: "type",
        filters: TypeFilter,
        onFilter: (value, record) => {
          if (record.type) {
            return record.type.includes(value);
          } else {
            return true;
          }
        },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Select>
                {Object.keys(WayMapper).map((key) => (
                  <Select.Option value={key}>
                    {WayMapper[key].title}
                  </Select.Option>
                ))}
              </Select>
            );
          }
        },
        render: (text, row) => (
          <div>{WayMapper[text] ? WayMapper[text].title : ""}</div>
        ),
      },
      // title
      {
        title: "نام",
        width: 130,
        dataIndex: "title",
        searchable: true,
      },
      // product
      {
        title: <span style={{ whiteSpace: "nowrap" }}>نوع محصول</span>,
        width: 120,
        dataIndex: "productTags",
        filters: productTags?.map((el) => ({ value: el, text: el })),

        onFilter: (value, record) => record?.productTags?.includes(value),
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Select
                defaultValue={record.productTags}
                mode="tags"
                allowClear
                style={{ width: "100%" }}
                placeholder="نوع محصول"
              >
                {Array.from(new Set(productTags))?.map((tag) => (
                  <Select.Option key={tag} value={tag}>
                    {tag}
                  </Select.Option>
                ))}
              </Select>
            );
          }
        },
        render: (_, record) => {
          if (
            !Array.isArray(record.productTags) ||
            record?.productTags?.length === 0
          ) {
            return <Tag color="red">بدون تگ</Tag>;
          }
          return (
            record?.productTags?.map((el) => (
              <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
            )) ?? "-"
          );
        },
      },
      // tags
      {
        title: "تگ",
        width: 100,
        dataIndex: "tags",
        filterSearch: true,
        filters: (tags ?? [])?.map((el) => ({ value: el, text: el })),
        onFilter: (value, record) => record?.tags?.indexOf(value) !== -1,

        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Select
                defaultValue={record.tags}
                mode="tags"
                allowClear
                style={{ width: "100%" }}
                placeholder="تگ"
              >
                {(tags ?? [])?.map((tag) => (
                  <Select.Option key={tag} value={tag}>
                    {tag}
                  </Select.Option>
                ))}
              </Select>
            );
          }
        },
        render: (_, record) => {
          if (!Array.isArray(record.tags) || record?.tags?.length === 0) {
            return <Tag color="red">بدون تگ</Tag>;
          }
          return (
            record?.tags?.map((el) => (
              <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
            )) ?? "-"
          );
        },
      },
      // isFree
      {
        title: "هزینه",
        width: 110,
        dataIndex: "isFree",
        filterMultiple: false,
        filters: [
          {
            value: "رایگان",
            text: true,
          },
          {
            value: "پولی",
            text: false,
          },
        ],
        onFilter: (value, record) => record?.isFree === value,

        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            const defaultValue =
              typeof record.isFree === "boolean" ? record.isFree : null;

            return (
              <Select
                defaultValue={defaultValue}
                allowClear
                style={{ width: "100%" }}
                placeholder="هزینه"
              >
                <Select.Option value={false}>پولی</Select.Option>
                <Select.Option value={true}>رایگان</Select.Option>
              </Select>
            );
          }
        },
        render: (_, row) => {
          if (typeof row.isFree !== "boolean") {
            return (
              <Tag color="red" style={{ margin: "0.25rem" }}>
                نامشخص
              </Tag>
            );
          }

          return row.isFree ? (
            <Tag color="green" style={{ margin: "0.25rem" }}>
              رایگان
            </Tag>
          ) : (
            <Tag color="blue" style={{ margin: "0.25rem" }}>
              پولی
            </Tag>
          );
        },
      },
      // discountCode
      {
        title: (
          <span style={{ whiteSpace: "nowrap" }}>کد تخفیف روش یادگیری</span>
        ),
        dataIndex: "discountCode",
        width: 230,
        filters: discounts.map((discount) => ({
          text: discount.percentage
            ? `${discount.title} - ${discount?.percentage} درصد`
            : discount.title,
          value: discount.id,
        })),
        onFilter: (value, record) => record?.discountCode === value,

        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Select
                defaultValue={record.discountCode}
                allowClear
                style={{ width: "100%" }}
                placeholder="تخفیف"
              >
                {discounts.map((discount) => (
                  <Select.Option value={discount.id}>
                    {discount.percentage
                      ? `${discount.title} - ${discount?.percentage} درصد`
                      : discount.title}
                  </Select.Option>
                ))}
              </Select>
            );
          }
        },
        render: (_, row) => {
          const discount = discounts.find(({ id }) => id === row.discountCode);
          if (!discount) {
            return <Tag color="red">ندارد</Tag>;
          }

          return (
            <Tag color="green" style={{ margin: "0.25rem" }}>
              {discount.percentage
                ? `${discount.title} - ${discount?.percentage} درصد`
                : discount.title}
            </Tag>
          );
        },
      },
      {
        title: <span style={{ whiteSpace: "nowrap" }}>تاریخ انقضا</span>,
        dataIndex: "expireAt",
        width: 140,
        render: (text, record) => {
          if (!text) return "-";
          let date = new Date(text);

          // real payment date
          if (moment(date).isValid()) {
            const jalali = toJalaali(
              date.getFullYear(),
              date.getMonth() + 1,
              date.getDate()
            );
            return (
              <span dir="ltr">
                {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
                {date.toLocaleTimeString("eo", { hour12: false })}
              </span>
            );
          }

          return <span>-</span>;
        },
        renderFormItem: (_, { isEditable, record, ...ot }, ...o) => {
          if (isEditable) {
            return (
              <>
                <DatePicker
                  value={record.expireAt}
                  format="YYYY/MM/DD"
                  calendar={jalali}
                  locale={persian_fa}
                  render={(value, openCalendar) => {
                    setD(value);
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        {record.id !== expireExists && (
                          <Input value={value} onClick={openCalendar} />
                        )}

                        {record.id !== expireExists ? (
                          <ClearIcon
                            onClick={() => setExpireExists(record.id)}
                            fontSize="small"
                          />
                        ) : (
                          <AddIcon
                            onClick={() => setExpireExists()}
                            fontSize="small"
                          />
                        )}
                      </div>
                    );
                  }}
                />
              </>
            );
          }
        },
      },
      {
        title: "VPN",
        width: 90,
        dataIndex: "vpn",
        filters: [{ value: true, text: "VPN" }],
        onFilter: (value, record) => record?.vpn === value,
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Select
                defaultValue={
                  typeof record.vpn === "boolean" ? record.vpn : null
                }
                allowClear
                style={{ width: "100%" }}
                placeholder="-"
              >
                <Select.Option value={true}>VPN</Select.Option>
              </Select>
            );
          }
        },
        render: (_, row) => {
          if (typeof row.vpn !== "boolean") return "-";

          if (row?.vpn) return <Tag color="red">VPN</Tag>;
        },
      },
      {
        title: "توضیحات",
        width: 140,
        dataIndex: "description",
      },
      {
        title: <span style={{ whiteSpace: "nowrap" }}>مهارت‌های متصل</span>,
        width: 130,
        dataIndex: "skills",
        filters: [
          {
            value: "has_skill",
            text: "مهارت دار",
          },
          {
            value: "no_skill",
            text: "بدون مهارت",
          },
        ],
        onFilter: (value, record) => {
          let hasSkill = true;
          if (Array.isArray(record.skills)) {
            if (record.skills.length === 0) {
              hasSkill = false;
            }
          }
          switch (value) {
            case "has_skill":
              return hasSkill;
            case "no_skill":
              return !hasSkill;
            default:
              return hasSkill;
          }
        },
        // renderFormItem: (_, { isEditable, record  }) => {
        //   if (isEditable) {
        //     return (
        //       <div>
        //         {Array.isArray(record.links)
        //           ? record.links.map((link , index) =>
        //           <Tooltip title={link}>
        //           <Tag closable onClose={()=>{removeLink(link , record)}}>لینک {index + 1}</Tag>
        //           </Tooltip>)
        //           : null}
        //          <Button onClick={()=>{
        //         setOpenModal(true);
        //         setEditingRecord(record)
        //       }}>ساخت لینک جدید</Button>
        //       </div>
        //     );
        //   }
        // },
        render: (text, row) => {
          const ErrorElement = (
            <div>
              <ExclamationCircleFilled /> روش یادگیری به هیچ مهارتی متصل نیست.
            </div>
          );
          if (Array.isArray(row.skills)) {
            if (row.skills.length === 0) {
              return ErrorElement;
            }
            return (
              <div>
                {row.skills.map((skill, index) => (
                  <Tag style={{ margin: "0.25rem" }}>{skill.title}</Tag>
                ))}
              </div>
            );
          } else {
            return ErrorElement;
          }
        },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <>
                {Array.isArray(record.skills)
                  ? record.skills.map((el) => (
                      <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
                    ))
                  : null}
              </>
            );
          }
        },
      },
      {
        title: <span style={{ whiteSpace: "nowrap" }}>لینک‌ها</span>,
        width: 110,
        dataIndex: "links",
        filters: [
          {
            value: "has_link",
            text: "لینک دار",
          },
          {
            value: "no_link",
            text: "بدون لینک",
          },
        ],
        onFilter: (value, record) => {
          let hasLink = false;
          if (Array.isArray(record.links)) {
            if (record.links.length !== 0) {
              hasLink = true;
            }
          }
          switch (value) {
            case "has_link":
              return hasLink;
            case "no_link":
              return !hasLink;
            default:
              return hasLink;
          }
        },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return <LinksEditor />;
          }
        },
        render: (text, row) => {
          if (!Array.isArray(row.links) || row.links.length === 0) {
            return (
              <div>
                <WarningFilled /> روش یادگیری بدون لینک است.
              </div>
            );
          }
          return (
            <div>
              {row.links.map((l, i) => (
                <div key={i}>
                  <a target="_blank" rel="noreferrer" href={l}>
                    لینک {row.links.length > 1 ? i + 1 : ""}
                  </a>
                </div>
              ))}
            </div>
          );
        },
      },
      {
        title: <span style={{ whiteSpace: "nowrap" }}>تاریخ ساخت</span>,
        width: 120,
        align: "center",
        dataIndex: "createdAt",
        editable: false,
        sorter: (a, b) => {
          const Adate = new Date(a.createdAt);
          const Bdate = new Date(b.createdAt);

          return Bdate - Adate;
        },
        render: (text, record) => {
          const date = text ? new Date(text) : new Date();
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        },
      },
    ];

    if (CheckPermission("confirmReserves", permissions)) {
      arr.push({
        title: <span style={{ whiteSpace: "nowrap" }}>تایید سوپروایزر</span>,
        width: 130,
        dataIndex: "needToConfirm",
        align: "center",
        filters: [{ value: true, text: "در انتظار تایید" }],
        onFilter: (value, record) => {
          if (value) {
            return record?.reserveLink || record?.reserveTitle;
          }
        },

        render: (_, record) => {
          if (
            record?.reserveLink ||
            record?.reserveTitle ||
            !record.supervisorConfirm
          ) {
            return (
              <Button
                onClick={() => setConfirmRecord(record)}
                icon={<FmdBadIcon color="warning" fontSize="small" />}
              />
            );
          } else {
            return "-";
          }
        },
        renderFormItem: () => "-",
      });
    }

    return arr;
  }, [expireExists, permissions, tags, productTags]);

  const convertToEnglishNumbers = (str) => {
    const persianDigits = {
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    return str.replace(/[۰-۹٠-٩]/g, (match) => persianDigits[match]);
  };
  const lastQueryRef = useRef({ page: 1, pageSize: 100, filters: {} });

  const loadData = (page = 1, pageSize = 100, filters = {}) => {
    lastQueryRef.current = { page, pageSize, filters };
    api
      .get("/ways", {
        params: {
          page,
          pageSize,
          ...filters,
          include: rowSelection?.selectedRowKeys ?? [],
        },
      })
      .then((res) => {
        setData(res.data.data);
        setPagination(res.data.pagination);
      });
  };

  const loadExternalDiscountData = () => {
    api
      .get("/external-discount")
      .then((res) => setDiscounts(res.data))
      .catch(() => message.error("خطا در دریافت لیست کد تخفیف روش یادگیری"));
  };

  const calculateTags = (newArr = []) => {
    api.get("/ways/filters").then((res) => {
      const data = res.data;
      console.log("Ways filters response:", data);
      setProductTags(data.productsTagList ?? []);
      setTags(data.waysTagList ?? []);
    }).catch((err) => {
      console.error("Error fetching ways filters:", err);
      message.error("خطا در دریافت تگ‌ها");
    });
  };

  const normalizeLinks = (v) => {
    if (Array.isArray(v)) {
      return v
        .flatMap((s) => `${s}`.split(/[\n,]/))
        .map((s) => s.trim())
        .filter(Boolean);
    }
    if (typeof v === "string") {
      return v
        .split(/[\n,]/)
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [];
  };

  const onSave = (row, rowData) => {
    let oldData = null;
    [...data].forEach((item, index) => {
      if (item.id === row.id) {
        oldData = item;
      }
    });
    LoadingSetter();
    calculateTags(rowData.tags ?? []);
    const linksArr = normalizeLinks(rowData.links);
    if (oldData === null) {
      return api
        .post("/ways", {
          data: {
            title: rowData.title,
            discountCode: rowData.discountCode,
            description: rowData.description ? rowData.description : "-",
            type: rowData.type,
            tags: rowData.tags ?? [],
            productTags: rowData.productTags ?? [],
            isFree: rowData.isFree ?? undefined,
            vpn: rowData.vpn ?? undefined,
            expireAt: rowData?.expireAt?.toDate()
              ? new Date(rowData?.expireAt?.toDate())?.toISOString()
              : "",
            links: linksArr,
          },
        })
        .then((res) => {
          ClearLoading();

          // console.log(res.data);
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    } else {
      let expireDate = null;

      if (d?.toString() && rowData.id !== expireExists) {
        const momentDate = moment(
          convertToEnglishNumbers(d.toString()),
          "jYYYY/jMM/jDD"
        );
        const year = +momentDate.format("YYYY");
        const month = +momentDate.format("MM");
        const day = +momentDate.format("DD");
        const gg = toGregorian(year, month, day);
        expireDate = new Date(`${gg.gy}/${gg.gm}/${gg.gd}`);
      }

      return api
        .put("/ways/" + oldData.id, {
          data: {
            title: rowData.title,
            tags: rowData.tags ?? [],
            productTags: rowData.productTags ?? [],
            discountCode: rowData.discountCode,
            description: rowData.description ? rowData.description : "-",
            type: rowData.type,
            isFree: rowData.isFree ?? undefined,
            vpn: rowData.vpn ?? undefined,
            expireAt: expireDate?.toISOString() ?? "",

            links: linksArr,
          },
        })
        .then((res) => {
          // console.log(res.data);
          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        })
        .finally(() => {
          setD();
          setExpireExists();
        });
    }
  };

  const exportData = () => {
    const json = waysData.map((way) => {
      const wayObj = {
        نوع: WayMapper[way.type].title,
        "نام روش یادگیری": way.title,
        توضیحات: way.description,
      };
      way.skills.forEach((skill, index) => {
        wayObj[`مهارت متصل ${index + 1}`] = skill.title;
      });
      if (Array.isArray(way.links)) {
        way.links.forEach((link, index) => {
          wayObj[`لینک ${index + 1}`] = link;
        });
      }

      return wayObj;
    });
    ExportExcel(json, "روش‌های یادگیری");
  };

  const addNewLink = () => {
    if (newLink) {
      const newData = data;
      let newRecord = editingRecord;
      if (Array.isArray(newRecord.links)) {
        newRecord.links.push(newLink);
      } else {
        newRecord = { ...editingRecord, links: [newLink] };
      }

      const finalData = newData.map((el) => {
        if (el.id === editingRecord.id) {
          // console.log(el)
          return newRecord;
        }
        return el;
      });
      setData(finalData);
      setEditingRecord(null);
      setNewLink(null);
    }
  };

  const removeLink = (link, record) => {
    const newData = JSON.parse(JSON.stringify(data));
    let newRecord = JSON.parse(JSON.stringify(record));
    const links = newRecord.links.filter((e) => e !== link);
    record.links = links;
    newRecord.links = links;
    const finalData = newData.map((el) => {
      if (el.id === record.id) {
        // console.log(el)
        return newRecord;
      }
      return el;
    });
    setData([]);
    setTimeout(() => {
      setData(finalData);
    }, 1);
    setEditingRecord(newRecord);
  };

  const getExpireDateClass = (expireDate) => {
    if (!expireDate) return;
    const d = new Date(expireDate);
    if (d < new Date()) return "row_error";
    if (d - 7 * 24 * 3600_000 < new Date()) return "row_warning";
  };

  const filtersBeautify = (fData) => {
    const out = {};

    // Title search (from `searchable: true` column)
    if (fData.title?.at(0)) out.title = fData.title.at(0);

    // Multi-value attribute filters — pass as arrays
    if (fData.type?.at(0)) out.type = fData.type;
    if (fData.productTags?.at(0)) out.productTag = fData.productTags;
    if (fData.tags?.at(0)) out.wayTag = fData.tags;

    // Boolean attribute filters
    // The isFree column (incorrectly) uses Persian labels as `value`, so map them.
    if (fData.isFree?.at(0) != null) {
      const v = fData.isFree.at(0);
      if (v === "رایگان" || v === true) out.isFree = true;
      else if (v === "پولی" || v === false) out.isFree = false;
    }
    if (fData.vpn?.at(0) != null) {
      out.vpn = fData.vpn.at(0) === true || fData.vpn.at(0) === "true";
    }

    // Discount code filter (number ID)
    if (fData.discountCode?.at(0) != null) {
      out.discountCode = fData.discountCode.at(0);
    }

    // Skills filter (has_skill / no_skill)
    if (fData.skills?.at(0)) {
      const v = fData.skills.at(0);
      if (v === "has_skill") out.hasSkill = true;
      else if (v === "no_skill") out.hasSkill = false;
    }

    // Links filter (has_link / no_link)
    if (fData.links?.at(0)) {
      const v = fData.links.at(0);
      if (v === "has_link") out.hasLink = true;
      else if (v === "no_link") out.hasLink = false;
    }

    // Reserve / supervisor confirm filters
    if (fData.needToConfirm?.at(0)) out.reserve = fData.needToConfirm.at(0);

    return out;
  };

  useEffect(() => {
    loadExternalDiscountData();
    calculateTags();
  }, [waysData]);

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("ways_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
    // if (CheckPermission("confirmReserves", permissions)) {
    //   setColumns((p) => [
    //     ...p,
    //     {
    //       title: "تایید سوپروایزر",
    //       dataIndex: "needToConfirm",
    //       align: "center",
    //       filters: [{ value: true, text: "در انتظار تایید" }],
    //       onFilter: (value, record) => {
    //         if (value) {
    //           return record?.reserveLink || record?.reserveTitle;
    //         }
    //       },
    //       render: (_, record) => {
    //         if (record?.reserveLink || record?.reserveTitle) {
    //           return (
    //             <Button
    //               onClick={() => setConfirmRecord(record)}
    //               icon={<FmdBadIcon color="warning" fontSize="small" />}
    //             />
    //           );
    //         } else {
    //           return "-";
    //         }
    //       },
    //       renderFormItem: () => "-",
    //     },
    //   ]);
    // }
  }, [permissions]);

  useEffect(() => {
    loadData();
    loadExternalDiscountData();
    calculateTags();
  }, []);

  useEffect(() => {
    if (confirmRecord?.id) {
      api.get(`/ways/${confirmRecord?.id}/related-ways`).then((res) => {
        setConfirmRecordSkills(res.data);
      });
    }
  }, [confirmRecord]);

  const submitReserves = () => {
    const links = Array.isArray(confirmRecord.reserveLink)
      ? confirmRecord.reserveLink.filter((l) => `${l}`.trim().length > 0)
      : [];
    const title = confirmRecord.reserveTitle;
    api
      .post(`/ways/${confirmRecord.id}/confirm-reserve`, {
        ...(title ? { title } : {}),
        ...(links.length ? { link: links } : {}),
      })
      .then(() => {
        setConfirmRecord({});
        message.success("با موفقیت اپدیت شد");
        const { page, pageSize, filters } = lastQueryRef.current;
        loadData(page, pageSize, filters);
      })
      .catch((e) => message.error("خطا در آپدیت"));
  };

  return (
    <div>
      <DataTable
        header={{
          title: "روش‌های یادگیری",
          avatar: { icon: <NodeIndexOutlined />, size: "large" },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
        dynamicPagination
        keepPageOnSave
        filtersBeautify={filtersBeautify}
        recordsCount={pagination?.total}
        editable
        path="/ways"
        scroll={{ x: 2000, y: "calc(100vh - 20rem)" }}
        columns={columns}
        dataSource={data}
        setDataSource={setData}
        editableKeys={editableKeys}
        rowSelection={rowSelection}
        rowClassName={(record) => {
          if (Array.isArray(record.links)) {
            if (
              [...record.links].length === 0 &&
              `${record.links}`.length < 10
            ) {
              return "row_warning";
            }
          } else {
            return "row_warning";
          }
          if (Array.isArray(record.skills)) {
            if ([...record.skills].length === 0) {
              return "row_error";
            }
          } else {
            return "row_error";
          }

          return getExpireDateClass(record.expireAt);
        }}
        onSave={onSave}
        reload={loadData}
        recordDefault={{
          links: [],
          createdAt: new Date().toString(),
        }}
        permissionsPrefix="ways"
        setEditableRowKeys={setEditableRowKeys}
      />
      <Modal
        destroyOnClose
        centered
        open={openModal}
        onOk={() => {
          addNewLink();
          setOpenModal(false);
        }}
        onCancel={() => {
          setOpenModal(false);
          setNewLink(null);
        }}
      >
        <h2>ایجاد لینک جدید</h2>
        <p>لطفا لینک را در قالب https://example.com وارد کنید.</p>
        <Input
          defaultValue="https://"
          onChange={(e) => {
            setNewLink(e.target.value);
          }}
        />
      </Modal>

      {/* supervisor confirm */}
      <Modal
        destroyOnClose
        centered
        title="تایید تغییرات"
        open={confirmRecord?.id}
        onOk={submitReserves}
        onCancel={() => setConfirmRecord({})}
      >
        {confirmRecord?.reserveTitle && (
          <>
            <Form.Item
              label="عنوان قبلی"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input disabled value={confirmRecord.title} />
            </Form.Item>
            <Form.Item
              label="عنوان جدید"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input
                defaultValue={confirmRecord.reserveTitle}
                onChange={(e) =>
                  setConfirmRecord((p) => ({
                    ...p,
                    reserveTitle: e.target.value,
                  }))
                }
              />
            </Form.Item>
          </>
        )}

        {confirmRecord?.reserveLink && (
          <>
            <Form.Item
              label="لینک‌های قبلی"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              {(confirmRecord?.links ?? []).length === 0 ? (
                <Tag>ندارد</Tag>
              ) : (
                (confirmRecord?.links ?? []).map((l, i) => (
                  <Tag key={i} style={{ margin: "0.25rem" }}>
                    {l}
                  </Tag>
                ))
              )}
            </Form.Item>

            <Form.Item
              label="لینک‌های جدید"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Select
                mode="tags"
                defaultValue={confirmRecord.reserveLink ?? []}
                style={{ width: "100%" }}
                placeholder="لینک"
                tokenSeparators={[",", "\n"]}
                open={false}
                onChange={(vals) =>
                  setConfirmRecord((p) => ({
                    ...p,
                    reserveLink: vals,
                  }))
                }
              />
            </Form.Item>

            <Form.Item
              label="مهارت ها"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              {confirmRecordSkills.map((e) => (
                <Tag key={e.id}>{e.title}</Tag>
              ))}
            </Form.Item>
          </>
        )}
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    waysData: state.ways,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    loadData: (page = 1, pageSize = 100, filters = {}) =>
      dispatch(actions.getDatabase("41744", { page, pageSize, filters })),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Ways);
